import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"py-4",attrs:{"color":"rgb(16 16 16)","flat":"","tile":""}},[_c('h3',{staticClass:"mb-4"},[_vm._v("BETS")]),_c(VBtn,{staticClass:"black--text",attrs:{"tile":"","block":"","depressed":"","color":"rgb(248, 158, 2)","loading":_vm.busy},on:{"click":function($event){return _vm.submit()}}},[_vm._v(" CLEAR BETS HISTORY")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }